import { fadeInAnimation } from './../../../../../shared/src/lib/_animations/fade-in.animation';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  CountryDto,
  StateDto,
  LgaDto,
  ProjectTypeDto,
  ProjectCategoryDto,
  ClusterDto,
  ClusterCommunityDto,
  OilBlockDto,
  OilFieldDto,
  CommunityDto,
  DocumentCategoryDto,
  DocumentSubCategoryDto,
  GMOUDto,
  ProjectDto,
  CurrencyDto,
  ProjectStakeholderDto,
  ProjectClusterDto,
  ProjectPaymentDto,
  EpimsBankDetailDto,
  BankDto,
} from '@cradua/data';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ProjectReferencesService } from '../../services/project-references.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { ProjectModalComponent } from 'libs/shared/src/lib/components/project-modal/project-modal.component';
import Swal from 'sweetalert2';
import { ModalComponent } from 'libs/shared/src/lib/components/modal/modal.component';

@Component({
  selector: 'mrsoftapps-budget-performance',
  templateUrl: './budget-performance.component.html',
  styleUrls: ['./budget-performance.component.scss'],
  //  // make fade in animation available to this component
  animations: [fadeInAnimation],

  //  // attach the fade in animation to the host (root) element of this component
  host: { '[@fadeInAnimation]': '' },
})
export class BudgetPerformanceComponent implements OnInit {
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() projectTypes: ProjectTypeDto[];
  @Input() projectCategories: ProjectCategoryDto[];
  @Input() projectData: GMOUDto;
  @Input() oilBlocks: OilBlockDto[];
  @Input() oilFields: OilFieldDto[];
  @Input() communities: CommunityDto[];
  @Input() countries: CountryDto[];
  @Input() clusters: ClusterDto[];
  @Input() clusterCommunity: ClusterCommunityDto[];
  @Input() projectManagements: ProjectDto[];
  @Input() documentCategory: DocumentCategoryDto[];
  @Input() documentSubCategory: DocumentSubCategoryDto[];
  @Input() currencies: CurrencyDto[];
  @Input() projectStakeholders: ProjectStakeholderDto[];
  @Input() projectClusters: ProjectClusterDto[];
  @Input() projectPayments: ProjectPaymentDto[];
  @Input() bankDetails: EpimsBankDetailDto[];
  @Input() banks: BankDto[];
  @Input() gmous: GMOUDto[];

  @Output() changeEmit = new EventEmitter<any>();
  @Output() onActivityEmit = new EventEmitter<any>();
  @Output() taskEmit = new EventEmitter<any>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() onDeleteStakeholder = new EventEmitter<any>();
  @Output() onSaveProjectStakeholder = new EventEmitter<any>();
  @Output() onSaveProjectPayment = new EventEmitter<any>();
  @Output() onSaveProjectCluster = new EventEmitter<any>();
  @Output() onBankDetailEmit = new EventEmitter<any>();
  @Output() deleteBankDetailEvent = new EventEmitter<any>();
  @Output() getBankDetailEmit = new EventEmitter<any>();
  @Output() onDeleteCluster = new EventEmitter<any>();

  stakeholders = [
    {
      StakeholderName: 'Elvis Iria',
      StakeholderTypeName: 'General',
      StakeholderRole: 'HR',
      StakeholderAddress: 'Eleme road',
      ProjectId: null,
      StakeholderId: 'BA4289BC-7567-EA11-871F-DC53601E6869',
    },
    {
      StakeholderName: 'Julius Oko',
      StakeholderTypeName: 'General',
      StakeholderRole: 'Graphics',
      StakeholderAddress: 'Eleme road',
      ProjectId: null,
      StakeholderId: 'BA4289BC-7567-EA11-871F-DC53601E6869',
    },
    {
      StakeholderName: 'Daniel Agbor',
      StakeholderTypeName: 'General',
      StakeholderRole: 'Developer',
      StakeholderAddress: 'Eleme road',
      ProjectId: null,
      StakeholderId: 'BA4289BC-7567-EA11-871F-DC53601E6869',
    },
  ];

  projectForm: FormGroup;
  selectOptionForm: FormGroup;
  selectedGmous: any;
  ProjectData: ProjectDto | any;
  status = false;
  searchClusterValue = '';
  searchStakeholderValue = '';
  selectedValue: ProjectDto;
  genericFieldLabel: string;
  genericBlockLabel: string;
  selectedProject: ProjectDto[];
  selectedProjectId: string;
  totalAmountPaid: any;
  searchedStakeholders: ProjectStakeholderDto[] | any[];
  isAddStakeholder = false;
  filteredDelete = [];
  @ViewChild('stake', { static: false }) stake: ElementRef;
  moitorProjectForm: FormGroup;
  monitorProjectClusterForm: FormGroup;
  monitorProjectPaymentForm: FormGroup;
  newObject: any[] & ProjectStakeholderDto[];
  newClusterObject: any[] & ProjectClusterDto[];
  searchedClusters: ClusterDto[];
  isAddCluster = false;
  filteredDeleteCluster = [];
  CreatedById = '49a7b97a-e0b2-49c8-a878-adc753540e2n';
  SubscriberId = '49a7b97a-e0v2-49c8-u078-add753540e2a';
  SiteId = '49a7b97a-e0b2-49c8-a079-add753540e2n';
  filteredProjectPayments: ProjectPaymentDto[];
  filteredProjectStakeholders: ProjectStakeholderDto[];
  filteredProjectClusters: ProjectClusterDto[];

  constructor(
    private fb: FormBuilder,
    private projectRefService: ProjectReferencesService,
    public matDialog: MatDialog
  ) {}

  ngOnInit() {
    if (this.selectedProjectId) {
      this.selectedProjectValue(this.selectedProjectId);
    }
    this.selectFormValidate();
    this.monitorProjectFormArray();
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.filterProjectModal();
  }

  selectFormValidate() {
    this.selectOptionForm = this.fb.group({
      GMOUTypeId: [''],
      GMOUId: [''],
      ProjectId: [''],
    });
  }

  onClick(): void {
    this.stake.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  search(value: string) {
    // this.searchEmit.emit(value);
    !value
      ? (this.searchedStakeholders = null)
      : (this.searchedStakeholders = this.stakeholders.filter(
          (item) =>
            item.StakeholderName.toLowerCase().includes(value.toLowerCase()) ||
            item.StakeholderRole.toLowerCase().includes(value.toLowerCase()) ||
            item.StakeholderAddress.toLowerCase().includes(value.toLowerCase())
        ));
  }

  searchCluster(value: string) {
    // this.searchEmit.emit(value);
    !value
      ? (this.searchedClusters = null)
      : (this.searchedClusters = this.clusters.filter((item) =>
          item.ClusterName.toLowerCase().includes(value.toLowerCase())
        ));
  }

  monitorProjectFormArray() {
    this.moitorProjectForm = this.fb.group({
      MonitorProjects: this.fb.array([]),
    });
    this.monitorProjectClusterForm = this.fb.group({
      MonitorProjectClusters: this.fb.array([]),
    });
    this.monitorProjectPaymentForm = this.fb.group({
      MonitorProjectPayments: this.fb.array([]),
    });
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };

  getBeneficiaryName(id: string) {
    const foundName = this.bankDetails.find(
      (item) => item.id.toLowerCase() === id.toLowerCase()
    );
    return foundName ? foundName.BeneficiaryAccountName : null;
  }

  setProjectPayment(value: ProjectPaymentDto[]) {
    const control = this.monitorProjectPaymentForm.controls
      .MonitorProjectPayments as FormArray;
    value.forEach((item) => {
      control.push(
        this.fb.group({
          Amount: item.Amount,
          InvoiceNo: item.InvoiceNo,
          ProjectId: item.ProjectId,
          PaymentDescription: item.PaymentDescription,
          PaymentDate: item.PaymentDate,
          CurrencyId: item.CurrencyId,
          CreatedById: item.CreatedById,
          BeneficiaryId: item.BeneficiaryId,
          SubscriberId: item.SubscriberId,
          SiteId: item.SiteId,
          id: item.id,
        })
      );
    });

    if (value.length > 0) {
      this.totalAmountPaid = value
        .map((item) => item.Amount)
        .reduce((prev, next) => prev + next);
    }
  }

  setProjectStakeholder() {
    const control = this.moitorProjectForm.controls
      .MonitorProjects as FormArray;
    this.filteredProjectStakeholders.forEach((item) => {
      control.push(
        this.fb.group({
          StakeholderName: item.StakeholderName,
          StakeholderTypeName: item.StakeholderTypeName,
          ProjectId: item.ProjectId,
          StakeholderRole: item.StakeholderRole,
          StakeholderAddress: item.StakeholderAddress,
          CreatedById: item.CreatedById,
          SubscriberId: item.SubscriberId,
          SiteId: item.SiteId,
          id: item.id,
        })
      );
    });
  }

  setProjectCluster() {
    const control = this.monitorProjectClusterForm.controls
      .MonitorProjectClusters as FormArray;
    this.filteredProjectClusters.forEach((item) => {
      control.push(
        this.fb.group({
          ClusterName: item.ClusterName,
          ProjectId: item.ProjectId,
          id: item.id,
        })
      );
    });
  }

  addPayment(value) {
    const control = this.monitorProjectPaymentForm.controls
      .MonitorProjectPayments as FormArray;
    control.insert(
      0,
      this.fb.group({
        Amount: value.Amount,
        InvoiceNo: value.InvoiceNo,
        ProjectId: value.ProjectId,
        PaymentDescription: value.PaymentDescription,
        PaymentDate: value.PaymentDate,
        CurrencyId: value.CurrencyId,
        BeneficiaryId: value.BeneficiaryId,
        CreatedById: value.CreatedById,
        SubscriberId: value.SubscriberId,
        SiteId: value.SiteId,
      })
    );
  }

  saveProjectPayment() {
    const paymentValue = this.monitorProjectPaymentForm.value;
    this.onSaveProjectPayment.emit(paymentValue);
  }

  addStakeholder(value) {
    this.newObject = Object.assign([], this.selectedValue.projectStakeholders);
    const itemFound = this.moitorProjectForm.value.MonitorProjects.find(
      (item) =>
        item.StakeholderName.trim().toLowerCase() ===
        value.StakeholderName.trim().toLowerCase()
    );
    let alertMessage: string;

    if (!itemFound) {
      const control = this.moitorProjectForm.controls
        .MonitorProjects as FormArray;
      control.insert(
        0,
        this.fb.group({
          StakeholderName: value.StakeholderName,
          StakeholderTypeName: value.StakeholderTypeName,
          ProjectId: this.selectedProjectId,
          StakeholderRole: value.StakeholderRole,
          StakeholderAddress: value.StakeholderAddress,
          CreatedById: this.CreatedById,
          SubscriberId: this.SubscriberId,
          SiteId: this.SiteId,
        })
      );

      // this.onClick();
      alertMessage = ' has been added to stakeholder list, you can save now';
      Swal.fire(
        'Success!',
        this.StakeHolderAlertMessage(value.StakeholderName, alertMessage),
        'success'
      );
      this.isAddStakeholder = true;
      this.searchedStakeholders = null;
      this.searchStakeholderValue = null;
    } else {
      alertMessage = 'already exist, please add a different name!';
      Swal.fire(
        'Warning!',

        this.StakeHolderAlertMessage(value.StakeholderName, alertMessage),
        'warning'
      );
      this.onClick();
    }
  }

  addCluster(value) {
    this.newClusterObject = Object.assign(
      [],
      this.selectedValue.projectClusters
    );
    const itemFound = this.monitorProjectClusterForm.value.MonitorProjectClusters.find(
      (item) =>
        item.ClusterName.trim().toLowerCase() ===
        value.ClusterName.trim().toLowerCase()
    );
    let alertMessage: string;
    if (!itemFound) {
      const control = this.monitorProjectClusterForm.controls
        .MonitorProjectClusters as FormArray;
      control.insert(
        0,
        this.fb.group({
          ClusterName: value.ClusterName,
          ClusterId: value.ClusterId,
          ProjectId: this.selectedProjectId,
          CreatedById: this.CreatedById,
          SubscriberId: this.SubscriberId,
          SiteId: this.SiteId,
        })
      );

      // this.onClick();
      alertMessage = ' has been added to cluster list, you can save now';
      Swal.fire(
        'Success!',
        this.StakeHolderAlertMessage(value.ClusterName, alertMessage),
        'success'
      );
      this.isAddCluster = true;
      this.searchedClusters = null;
      this.searchClusterValue = null;
    } else {
      alertMessage = 'already exist, please add a different name!';
      Swal.fire(
        'Warning!',

        this.StakeHolderAlertMessage(value.ClusterName, alertMessage),
        'warning'
      );
      this.onClick();
    }
  }

  deleteProjectStakeholder(index: number, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.moitorProjectForm.controls
          .MonitorProjects as FormArray;
        control.removeAt(index);
        if (value.id != null && value.id !== '') {
          this.filteredDelete.push(value.id);
          this.isAddStakeholder = true;
        }

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  deleteProjectCluster(index: number, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.monitorProjectClusterForm.controls
          .MonitorProjectClusters as FormArray;
        control.removeAt(index);
        if (value.id !== undefined) {
          this.filteredDeleteCluster.push(value.id);
          this.isAddCluster = true;
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  StakeHolderAlertMessage(name, message) {
    return `
      <div style="color:#04012d; font-size: 16px; margin: 2px;">
      <strong>${name}</strong>
      </div>
      <div>
      ${message}
      </div>
      `;
  }

  saveStakeholder() {
    this.newObject = this.moitorProjectForm.value;
    console.log('stakeholder ', this.newObject);
    // this.selectedValue = Object.assign({}, this.selectedValue, {
    //  projectStakeholders: this.newObject
    // });

    if (this.filteredDelete.length !== 0) {
      this.onDeleteStakeholder.emit(this.filteredDelete);
    }
    this.onSaveProjectStakeholder.emit(this.newObject);
    this.searchStakeholderValue = null;
  }

  saveCluster() {
    console.log('save');
    this.newClusterObject = this.monitorProjectClusterForm.value;

    if (this.filteredDeleteCluster.length !== 0) {
      this.onDeleteCluster.emit(this.filteredDeleteCluster);
    }
    this.onSaveProjectCluster.emit(this.newClusterObject);

    this.searchClusterValue = null;
  }

  filterProjectModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '400px';
    dialogConfig.width = '30%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      name: 'selectOptions',
      projects: this.projectManagements,
      projectCategories: this.projectCategories,
      projectTypes: this.projectTypes,
      selectedProject: this.selectedValue,
      gmous: this.gmous,
    };

    const modalDialog = this.matDialog.open(
      ProjectModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.selectProject(result);
      }
    });
  }

  openViewPaymentModal(value) {
    // console.log('view ', this.bankDetails)
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '600px';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.width = '50%';
    dialogConfig.data = {
      name: 'viewBudgetPayment',
      selectedProject: this.selectedValue,
      banks: this.banks,
      selectedProjectPayment: value,
      bankDetail: this.getBankDetailObject(value.BeneficiaryId),
      currencies: this.currencies,
    };

    const modalDialog = this.matDialog.open(
      ProjectModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
      if (result !== undefined) {
        // this.paymentEmit.emit(result);
      }
    });
  }

  getBankDetailObject(id: string): EpimsBankDetailDto {
    const foundObject = this.bankDetails.find(
      (item) => item.id.toLowerCase() === id.toLowerCase()
    );
    return foundObject && foundObject;
  }

  openCreateBankDetailModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '700px';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.width = '90%';
    dialogConfig.data = {
      name: 'bankDetail',
      student: this.selectedValue,
      bankDetails: this.bankDetails,
      banks: this.banks,
    };

    const modalDialog = this.matDialog.open(ModalComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        if (result.type === 'save') {
          this.onBankDetailEmit.emit(result.formValue);
        }

        if (result.filteredDelete !== null) {
          this.deleteBankDetailEvent.emit(result.filteredDelete);
        }
      }
    });
  }

  openCreatePaymentModal() {
    if (this.bankDetails.length === 0) {
      this.openCreateBankDetailModal();
    } else {
      const dialogConfig = new MatDialogConfig();
      // The user can't close the dialog by clicking outside its body
      dialogConfig.disableClose = false;
      dialogConfig.id = 'modal-component';
      dialogConfig.height = '600px';
      dialogConfig.width = '60%';
      dialogConfig.backdropClass = 'backdropBackground';
      dialogConfig.data = {
        name: 'createProjectPayment',
        projects: this.projectManagements,
        projectCategories: this.projectCategories,
        projectTypes: this.projectTypes,
        selectedProject: this.selectedValue,
        projectPayments: this.projectPayments,
        currencies: this.currencies,
        bankDetails: this.bankDetails,
      };

      const modalDialog = this.matDialog.open(
        ProjectModalComponent,
        dialogConfig
      );
      modalDialog.afterClosed().subscribe((result) => {
        if (result !== undefined) {
          if (result === 'bankDetail') {
            this.openCreateBankDetailModal();
          } else {
            this.addPayment(result[0]);
          }
        }
      });
    }
  }

  /* Handle form errors in Angular 8 */
  public errorHandling = (control: string, error: string) => {
    return this.projectForm.controls[control].hasError(error);
  };

  getCurrencyName(id) {
    return this.projectRefService.currencyName(this.currencies, id);
  }

  selectProjectType(event) {
    this.selectedGmous = this.gmous.filter(
      (item) => item.GMOUTypeId === event.value
    );
  }

  selectGMOU(id: string) {
    this.selectedProject = this.projectManagements.filter(
      (item) => item.GMOUId === id
    );
  }

  selectedProjectValue(id) {
    this.selectedValue = this.projectManagements.find((item) => item.id === id);
  }

  filteredProjectPayment(id: string) {
    this.filteredProjectPayments = this.projectPayments.filter(
      (item) => item.ProjectId.trim().toLowerCase() === id.trim().toLowerCase()
    );
    this.setProjectPayment(this.filteredProjectPayments);
  }

  filteredProjectStakeholder(id: string) {
    this.filteredProjectStakeholders = this.projectStakeholders.filter(
      (item) => item.ProjectId.toLowerCase() === id.toLowerCase()
    );

    const control = this.moitorProjectForm.controls
      .MonitorProjects as FormArray;
    if (this.filteredProjectStakeholders.length > 0) {
      this.clearFormArray(control);
      this.setProjectStakeholder();
    } else {
      this.clearFormArray(control);
    }
  }

  filteredProjectCluster(id: string) {
    this.filteredProjectClusters = this.projectClusters.filter(
      (item) => item.ProjectId.toLowerCase() === id.toLowerCase()
    );

    const control = this.monitorProjectClusterForm.controls
      .MonitorProjectClusters as FormArray;
    if (this.filteredProjectClusters.length > 0) {
      this.clearFormArray(control);
      this.setProjectCluster();
    } else {
      this.clearFormArray(control);
    }
  }

  selectProject(id: string) {
    const value: ProjectDto = this.projectManagements.find(
      (item) => item.id === id
    );
    if (value) {
      this.selectedValue = value;
      this.filteredProjectPayment(id);
      this.filteredProjectStakeholder(id);
      this.filteredProjectCluster(id);
      this.selectedProjectId = value.id;
      this.getBankDetailEmit.emit(this.selectedProjectId);
      this.ProjectData = {
        id: value.id,
        ProjectTitle: value.ProjectTitle,
        Description: value.Description,
        GMOUCategoryId: this.projectRefService.projectCategoryName(
          this.projectCategories,
          value.GMOUCategoryId
        ),
        GMOUTypeId: this.projectRefService.projectTypeName(
          this.projectTypes,
          value.GMOUTypeId
        ),
        Lgas: this.projectRefService.getLgaArray(this.lgas, value.LGAId),
        States: this.projectRefService.getStateArray(
          this.states,
          value.StateId
        ),
        OilBlocks: this.projectRefService.getOilBlockArray(
          this.oilBlocks,
          value.OilBlocId
        ),
        OilFields: this.projectRefService.getOilFieldArray(
          this.oilFields,
          value.OilFieldId
        ),
        Budget: value.Budget,
        EndDate: value.EndDate,
        StartDate: value.StartDate,
        Executor: value.Executor,
        GMOUId: value.GMOUId,
      };

      if (this.oilFields.length > 0) {
        this.genericFieldLabel = this.oilFields[0].LabelName;
        this.genericBlockLabel = this.oilBlocks[0].LabelName;
      }

      if (value.projectPayments.length > 0) {
        // this.totalAmountPaid = value.projectPayments.filter(x => x.ProjectId === value.id).map(item => item.Amount).reduce((prev, next) => prev + next);
      } else {
        this.totalAmountPaid = 0;
      }
      this.status = true;
    }
  }

  getState(id) {
    const selectedLga = this.lgas.find((item) => item.id === id);

    if (!selectedLga) {
      return;
    }

    const selectedState = this.states.find(
      (item) => item.id === selectedLga.StateId
    );

    if (!selectedState) {
      return;
    }

    return selectedState;
  }

  getProjectCategory(id) {
    const selectedType = this.projectTypes.find((item) => item.id === id);
    if (!selectedType) {
      return;
    }

    const selectedCategory = this.projectCategories.find(
      (item) => item.id === selectedType.ProjectCategoryId
    );

    if (!selectedCategory) {
      return;
    }

    return selectedCategory;
  }

  getOilBlock(id) {
    const selectedOilField = this.oilFields.find((item) => item.id === id);
    if (!selectedOilField) {
      return;
    }

    const selectedOilBlock = this.oilBlocks.find(
      (item) => item.id === selectedOilField.OilBlockId
    );

    if (!selectedOilBlock) {
      return;
    }

    return selectedOilBlock;
  }

  onSubmit(formValue: ProjectDto) {
    const selectedProjectType = this.getProjectCategory(formValue.GMOUTypeId);
    formValue.GMOUCategoryId = selectedProjectType.id;
    formValue.OilBlocId = this.selectedValue.OilBlocId;
    formValue.OilFieldId = this.selectedValue.OilFieldId;
    formValue.StateId = this.selectedValue.OilFieldId;
    formValue.LGAId = this.selectedValue.LGAId;

    this.changeEmit.emit(formValue);
  }
}
